<template>
  <v-app id="inspire">
    <div v-if="pageType === 'intro'">
      <ServiceInit></ServiceInit>
    </div>
    <div v-else-if="pageType !== 'intro' && $route.meta && $route.meta.hideLayout">
      <!-- 레이아웃 없는 페이지 (Login, Join) -->
      <router-view></router-view>
      <Alert></Alert>
    </div>
    <div v-else-if="pageType !== 'intro' && !($route.meta && $route.meta.hideLayout)">
      <!-- 기본 레이아웃 (상단바 + 사이드바) -->
      <v-navigation-drawer v-model="drawer" :clipped="$vuetify.breakpoint.lgAndUp" app ref="appNavigation">
        <v-list dense>
          <select name="" @change="changeShop()" v-model="select_shop_no" class="my-3 ml-4 shopListSelect">
            <option v-for="(item, index) in this.shops" :value="item.shop_no" :selected="item.shop_no === select_shop_no" :key="index">
              {{ item.shop_name }}
            </option>
          </select>
          <template v-for="item in displayItems">
            <v-list-item :key="item.text" link :disabled="checkMenuDisabled(item)" @click="checkVersionAlret($event)">
              <router-link class="navigation-router-link" :to="item.toPath">
                <v-list-item-action>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    <p class="mb-0 subtitle-2">{{ item.text }}</p>
                  </v-list-item-title>
                </v-list-item-content>
              </router-link>
            </v-list-item>
          </template>
        </v-list>
      </v-navigation-drawer>
      <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app color="blue darken-3" dark ref="appBar">
        <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
        <v-toolbar-title style="width: 250px" class="pl-4 ml-0">
          <span class="hidden-sm-and-down">{{ appTitle }}</span>
        </v-toolbar-title>

        <div v-if="CONFIG.NODE_ENV === 'development'">
          <v-btn
            color="warning"
            v-if="$store.state.mode === AUTH_SERVICE.APP_MODE.BASIC"
            @click.prevent="changeVersion(AUTH_SERVICE.APP_MODE.PLUS)"
            >베이직(개발모드에서만 보임)</v-btn
          >
          <v-btn color="info" v-else @click.prevent="changeVersion(AUTH_SERVICE.APP_MODE.BASIC)">플러스(개발모드에서만 보임)</v-btn>
        </div>
        <v-spacer />
        <AppVersion></AppVersion>
      </v-app-bar>
      <v-content>
        <v-container class="height" fluid>
          <router-view></router-view>
        </v-container>
      </v-content>
      <ProgressDialog></ProgressDialog>
      <CircularProgress></CircularProgress>
      <Alert></Alert>
    </div>
  </v-app>
</template>

<style scoped>
.shopListSelect {
  height: 36px;
  width: 225px;
  border-radius: 4px;
  background-color: #fff;
  border: 1px #ccc solid;
  padding: 5px;
  padding-left: 13px;
  padding-right: 30px;
  box-shadow: inset 1px 1px 3px 0 rgba(0, 0, 0, 0.1);
  color: black;
  font-size: 1em;
  background-image: linear-gradient(45deg, transparent 50%, currentColor 50%), linear-gradient(135deg, currentColor 50%, transparent 50%);
  background-position: calc(100% - 20px) calc(1px + 50%), calc(100% - 16.1px) calc(1px + 50%);
  background-size: 4px 4px, 4px 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.navigation-router-link {
  color: unset;
  text-decoration: none;
  width: 100%;
  display: flex;
}

.v-list-item--disabled {
  pointer-events: auto;
}
@font-face {
  font-family: "Material Design Icons";
  src: url("https://cdnjs.cloudflare.com/ajax/libs/MaterialDesign-Webfont/7.4.47/fonts/materialdesignicons-webfont.woff2?v=7.4.47")
    format("woff2");
  font-display: block; /* 폰트 로딩까지 대기 */
}

.v-icon {
  font-family: "Material Design Icons" !important;
}
</style>

<script>
import CommonMixin from "@/mixins/CommonMixin.js";
import ServiceInit from "@/views/authservice/ServiceInit.vue";
import AppVersion from "@/components/authservice/version/AppVersion.vue";
import ProgressDialog from "@/components/common/ProgressDialog.vue";
import CircularProgress from "@/components/common/CircularProgress.vue";
import Alert from "@/components/common/Alert.vue";
import { AUTH_SERVICE } from "@/datas/authservice";
import { CONFIG } from "@/datas/configs.js";
import M from "@/libs/mapping.js";

export default {
  components: {
    ServiceInit,
    AppVersion,
    ProgressDialog,
    CircularProgress,
    Alert,
  },
  props: {
    source: String,
  },
  data() {
    return {
      AUTH_SERVICE,
      CONFIG,
      pageType: "intro",
      appTitle: "정품 인증 서비스", // created에서 동적으로 변경
      drawer: null,
      unPlus: {
        color: "#8C8C8C",
      },
      select_shop_no: this.$store.state.shopNo, // this.$store.state.mallType === "imweb" ? this.$store.state.mallId : this.$store.state.shopNo,
      shops: [],
      // 일반 제품 인증 메뉴 아이템
      certProductItems: [
        {
          icon: "mdi-label-multiple-outline",
          text: "서비스 소개",
          toPath: `/authservice/${this.$store.state.mallId}/serviceIntro`,
          version: AUTH_SERVICE.APP_MODE.ANY,
          appCode: "common",
        },
        {
          icon: "mdi-cog-outline",
          text: "정품 인증 설정",
          toPath: `/authservice/${this.$store.state.mallId}/warrantyPeriod`,
          version: AUTH_SERVICE.APP_MODE.BASIC,
          appCode: "cert_product",
        },
        {
          icon: "mdi-barcode",
          text: "정품 인증 코드 생성",
          toPath: `/authservice/${this.$store.state.mallId}/createAuthcode`,
          version: AUTH_SERVICE.APP_MODE.BASIC,
          appCode: "cert_product",
        },
        {
          icon: "mdi-barcode-scan",
          text: "정품 인증 코드 관리",
          toPath: `/authservice/${this.$store.state.mallId}/manageAuthcode`,
          version: AUTH_SERVICE.APP_MODE.BASIC,
          appCode: "cert_product",
        },
        {
          icon: "mdi-account-supervisor",
          text: "정품 인증 회원 관리",
          toPath: `/authservice/${this.$store.state.mallId}/manageAuthMembers`,
          version: AUTH_SERVICE.APP_MODE.PLUS,
          appCode: "cert_product",
        },
        {
          icon: "mdi-face-agent",
          text: "A/S 신청 관리",
          toPath: `/authservice/${this.$store.state.mallId}/manageAs`,
          version: AUTH_SERVICE.APP_MODE.PLUS,
          appCode: "cert_product",
        },
        {
          icon: "mdi-cctv",
          text: "분실 상품 이력 관리",
          toPath: `/authservice/${this.$store.state.mallId}/lostRecord`,
          version: AUTH_SERVICE.APP_MODE.PLUS,
          appCode: "cert_product",
        },
        {
          icon: "mdi-qrcode",
          text: "정품 QR 코드 인쇄 설정",
          toPath: `/authservice/${this.$store.state.mallId}/printqr`,
          version: AUTH_SERVICE.APP_MODE.PLUS,
          appCode: "cert_product",
        },
        {
          icon: "mdi-message-processing-outline",
          text: "카톡/SMS/메일 발송 관리",
          toPath: `/authservice/${this.$store.state.mallId}/messageManage`,
          version: AUTH_SERVICE.APP_MODE.PLUS,
          appCode: "common",
        },
        {
          icon: "mdi-store",
          text: "쇼핑몰 설정",
          toPath: `/authservice/${this.$store.state.mallId}/setting`,
          version: AUTH_SERVICE.APP_MODE.BASIC,
          appCode: "cert_product",
        },
        {
          icon: "mdi-clipboard-plus-outline",
          text: "부가서비스",
          toPath: `/authservice/${this.$store.state.mallId}/additionalService`,
          version: AUTH_SERVICE.APP_MODE.ANY,
          appCode: "common",
        },
        {
          icon: "mdi-credit-card-outline",
          text: "결제 관리",
          toPath: `/authservice/${this.$store.state.mallId}/payment`,
          version: AUTH_SERVICE.APP_MODE.ANY,
          appCode: "common",
        },
      ],
      // 디지털 제품 인증 메뉴 아이템
      digitalItems: [
        {
          icon: "mdi-cog-outline",
          text: "디지털 상품 인증 설정",
          toPath: `/authservice/${this.$store.state.mallId}/digital/warrantyPeriod`,
          version: AUTH_SERVICE.APP_MODE.BASIC,
          appCode: "cert_digital",
        },
        {
          icon: "mdi-barcode",
          text: "디지털 상품 코드 등록",
          toPath: `/authservice/${this.$store.state.mallId}/digital/createAuthcode`,
          version: AUTH_SERVICE.APP_MODE.BASIC,
          appCode: "cert_digital",
        },
        {
          icon: "mdi-barcode-scan",
          text: "디지털 상품 코드 관리",
          toPath: `/authservice/${this.$store.state.mallId}/digital/manageAuthcode`,
          version: AUTH_SERVICE.APP_MODE.BASIC,
          appCode: "cert_digital",
        },
        {
          icon: "mdi-message-processing-outline",
          text: "SMS/메일 발송 관리",
          toPath: `/authservice/${this.$store.state.mallId}/messageManage`,
          version: AUTH_SERVICE.APP_MODE.PLUS,
          appCode: "common",
        },
        {
          icon: "mdi-clipboard-plus-outline",
          text: "부가서비스",
          // 원본 authservice 폴더의 뷰 사용
          toPath: `/authservice/${this.$store.state.mallId}/additionalService`,
          version: AUTH_SERVICE.APP_MODE.ANY,
          appCode: "common",
        },
        {
          icon: "mdi-credit-card-outline",
          text: "결제 관리",
          // 원본 authservice 폴더의 뷰 사용
          toPath: `/authservice/${this.$store.state.mallId}/payment`,
          version: AUTH_SERVICE.APP_MODE.ANY,
          appCode: "common",
        },
      ],
      // 기본 메뉴 아이템 설정 (certProductItems를 기본값으로 사용)
    };
  },
  mixins: [CommonMixin],
  watch: {
    // 라우트 변경 감지하여 레이아웃 타입에 따른 처리
    /*
    $route(to, from) {
      // 레이아웃 없는 페이지에서 레이아웃 있는 페이지로 전환시 또는 from이 null인 경우 초기화
      console.log("route check", from?.meta, from?.meta?.hideLayout, to.meta, from, to);
      if (from.name === null || (from.meta && from.meta.hideLayout && !(to.meta && to.meta.hideLayout))) {
        console.log("Transitioning from layout-less to layout page or from null, initializing shop list");
        this.getShopList();
      } else if (to.name === "ServiceIntro") {
        this.getShopList();
      }
    },
    */
  },
  computed: {
    displayItems: function() {
      // 레이아웃 없는 페이지에서는 메뉴 아이템 불필요
      /*
      if (this.$route.meta && this.$route.meta.hideLayout) {
        return [];
      }
        */

      // appCode에 따라 표시할 메뉴 아이템 결정
      const appCode = this.$store.state.appCode || "cert_product";
      const mallType = this.$store.state.mallType || "mall";

      if (appCode === "cert_digital") {
        return this.digitalItems;
      } else {
        let items = this.certProductItems;

        if (mallType === "imweb") {
          // imweb 타입일 때 messageManage와 lostRecord를 제외한 메뉴 아이템 반환
          items = items.filter(
            (item) =>
              item.toPath !== `/authservice/${this.$store.state.mallId}/messageManage` &&
              item.toPath !== `/authservice/${this.$store.state.mallId}/lostRecord`,
          );
        }

        // A/S 메뉴 노출 여부 체크 (M.isCustomCheck 활용)
        // surping1_as_custom이 아닌 경우 A/S 메뉴 제거
        const customCheck = M.isCustomCheck();
        if (customCheck !== "as_custom") {
          items = items.filter((item) => item.toPath !== `/authservice/${this.$store.state.mallId}/manageAs`);
        }

        return items;
      }
    },
    mallType: function() {
      return this.$store.state.mallType || "cafe24";
    },
  },
  created: function() {
    // mallType 스마트 초기화
    this.initializeMallType();

    // appCode에 따라 문서 제목 설정
    const appCode = this.$store.state.appCode || "cert_product";
    document.title = appCode === "cert_digital" ? "디지털 상품 인증 서비스" : "정품 인증 서비스";
    this.appTitle = document.title; // 앱 제목도 함께 업데이트

    this.pageType = this.$router.app.path === "/authservice/init" ? "intro" : "page";
  },
  mounted: function() {
    // 레이아웃 없는 페이지 (로그인, 회원가입 등)에서는 초기화 로직 건너뛰기
    //*
    if (this.$route.meta && this.$route.meta.hideLayout) {
      console.log("Layout-less page detected, skipping shop list initialization");
      return;
    }

    // 기본 레이아웃 페이지에서만 shop list 가져오기
    const hideLayoutPaths = [
      "/authservice/login",
      "/authservice/join",
      "/authservice/find-password",
      "/authservice/reset-password",
      "member/login",
    ];
    if (hideLayoutPaths.some((path) => window.location.href.includes(path))) {
      console.log("Current path is a layout-less page, skipping shop list initialization");
      return;
    }
    //  */
    this.getShopList();
  },
  methods: {
    /**
     * mallType 스마트 초기화
     * 1. URL query parameter에서 mType 검사
     * 2. sessionStorage에서 shoplus_cert_mallType 검사
     * 3. store에 설정 및 sessionStorage 동기화
     */
    initializeMallType: function() {
      // 1. URL query parameter에서 mType 검사
      const queryMType = this.$route.query.mType;

      // 2. sessionStorage에서 기존 mallType 검사
      const sessionMallType = sessionStorage.getItem("shoplus_cert_mallType");

      // 3. 현재 store의 mallType 검사
      const currentMallType = this.$store.state.mallType;

      let finalMallType = null;

      // 우선순위: query > session > current
      if (queryMType) {
        finalMallType = queryMType;
        console.log("[mallType] Set from URL query:", finalMallType);
      } else if (sessionMallType) {
        finalMallType = sessionMallType;
        console.log("[mallType] Set from sessionStorage:", finalMallType);
      } else if (currentMallType) {
        finalMallType = currentMallType;
        console.log("[mallType] Keep current store value:", finalMallType);
      }

      // store와 sessionStorage 동기화
      if (finalMallType) {
        // store 업데이트
        if (this.$store.state.mallType !== finalMallType) {
          this.$store.commit("SET_MALL_TYPE", finalMallType);
        }

        // sessionStorage 업데이트
        if (sessionStorage.getItem("shoplus_cert_mallType") !== finalMallType) {
          sessionStorage.setItem("shoplus_cert_mallType", finalMallType);
        }
      } else {
        // 모두 비어있으면 초기화
        console.log("[mallType] No mallType found, clearing all");
        this.$store.commit("SET_MALL_TYPE", null);
        sessionStorage.removeItem("shoplus_cert_mallType");
      }
    },

    setSelectShop: function() {
      // console.log("Setting selected shop for mallType:", this.mallType, this.select_shop_no);
      if (this.mallType === "imweb") {
        this.shops.forEach((item) => {
          if ((this.select_shop_no === null || this.select_shop_no === "1") && item.default === "T") {
            this.select_shop_no = item.shop_no;
          }
        });
        this.$store.dispatch("CHANGE_SHOPNO", this.select_shop_no);
      } else {
        this.select_shop_no = this.$store.state.shopNo;
      }

      this.shops.forEach((item) => {
        // console.log("item", item);
        if (this.select_shop_no === item.shop_no) {
          sessionStorage.setItem(`${this.$store.state.mallId}_domain`, item.primary_domain);
          if (this.mallType === "imweb") {
            // 이메일에서 @ 앞의 부분만 추출하여 shop_id로 사용
            const email = item.email || "";
            const shop_id = email.split("@")[0];
            if (shop_id) {
              this.$store.dispatch("SET_SHOP_ID", shop_id);
            }
          }
        }
      });
    },
    getShopList: async function() {
      console.log("App get shoplist");
      try {
        this.select_shop_no = localStorage.getItem(`${this.$store.state.appCode}_${this.$store.state.mallId}_shop_no`);
        const data = await M.api(M.entry("/get/shops"));
        this.shops = data.sort((a, b) => a.shop_no - b.shop_no);
        this.setSelectShop();
        this.$store.dispatch("CHANGE_SHOPNO", this.select_shop_no);
      } catch (error) {
        console.error("Error fetching shop list:", error);
      }
    },
    changeShop: async function() {
      // 쇼핑몰 변경히 해당 결제 타입체크
      let is_set_version = false;
      try {
        let data = await M.api(M.entry("/cert/products/class", { shop_no: this.select_shop_no }));
        /*
        if (this.select_shop_no != '1') {
          data = null;
        }
          */
        this.shops.forEach((item) => {
          if (this.select_shop_no === item.shop_no) {
            sessionStorage.setItem(`${this.$store.state.mallId}_domain`, item.primary_domain);
            this.$store.dispatch("CHANGE_SHOPNO", this.select_shop_no);
          }
        });
        if (data && Object.prototype.hasOwnProperty.call(data, "class") && data.class) {
          // 이용중인 서비스가 있다면 페이지 리로드
          window.location.reload();
        } else {
          //*
          if (this.$store.state.appCode === "cert_product") {
            const chk_path = [
              `/authservice/${this.$store.state.mallId}/serviceIntro`,
              `/authservice/${this.$store.state.mallId}/additionalService`,
              `/authservice/${this.$store.state.mallId}/payment`,
            ];
            if (!chk_path.includes(this.$router.currentRoute.path)) {
              is_set_version = true;
              this.$router.push(`/authservice/${this.$store.state.mallId}/serviceIntro`);
            }
          } else {
            const chk_digital_path = [
              `/authservice/${this.$store.state.mallId}/additionalService`,
              `/authservice/${this.$store.state.mallId}/payment`,
            ];
            if (!chk_digital_path.includes(this.$router.currentRoute.path)) {
              this.$router.push(`/authservice/${this.$store.state.mallId}/payment`);
            }
          }
          window.location.reload();
          //  */
        }
      } catch (e) {
        console.log("fail get class");
      } finally {
        this.$store.dispatch("CHANGE_SHOPNO", this.select_shop_no);
        if (is_set_version) {
          this.$store.dispatch("SET_CERT_PRODUCTS_VERSION");
        }
      }
    },
    changeVersion: function(version) {
      this.$store.dispatch("CHANGE_VERSION", version);
    },
    checkVersionAlret: function(e) {
      // disabled 클래스 체크하여 얼럿 띄우기
      let disabledEl = e.target.closest(".v-list-item--disabled");
      let msg =
        this.$store.state.mode === AUTH_SERVICE.APP_MODE.ANY
          ? "사용 기간이 만료되었습니다.</br>결제 관리 메뉴에서 결제 후 사용이 가능합니다"
          : "해당 메뉴는 '플러스 버전' 에서 사용이 가능합니다.</br>[결제관리] 메뉴에서 버전을 변경/결제하여 사용해주세요.";
      if (disabledEl !== null) {
        this.alertShow(msg);
        e.stopPropagation();
      }
    },
    checkMenuDisabled: function(item) {
      let mode = this.$store.state.mode;
      if (mode === AUTH_SERVICE.APP_MODE.ANY) {
        if (item.version !== AUTH_SERVICE.APP_MODE.ANY) {
          return true;
        }
      } else {
        if (mode === AUTH_SERVICE.APP_MODE.BASIC) {
          if (item.version === AUTH_SERVICE.APP_MODE.PLUS) {
            return true;
          }
        }
      }

      return false;
    },

    /**
     * mallType 및 관련 sessionStorage 초기화
     */
    clearMallType: function() {
      try {
        // store 초기화
        if (this.$store && this.$store.state) {
          this.$store.commit("SET_MALL_TYPE", null);
        }

        // sessionStorage 초기화
        sessionStorage.removeItem("shoplus_cert_mallType");

        console.log("[mallType] Cleared mallType and sessionStorage");
      } catch (error) {
        console.error("[mallType] Error clearing mallType:", error);
      }
    },
  },

  beforeDestroy() {
    // 컴포넌트 파괴 시 mallType 초기화
    this.clearMallType();
    this.drawer = false;
  },
};
</script>
